import React from "react"
import { Provider } from "react-redux"
import { store } from "./store"

interface WrapRootElementProps {
	element: React.ReactNode
}

// Simple wrapper that just provides Redux store
// PersistGate is problematic with SSR/hydration, so we skip it entirely
// The store will still persist via redux-persist, just without the gate
export const WrapRootElement: React.FC<WrapRootElementProps> = ({ element }) => {
	return <Provider store={store}>{element}</Provider>
}
